import axiosInstance from "../../../api/axiosConfig";
import { AddUser, User } from '../types/user';

export const createUser = async (user: AddUser) => {
    const response = await axiosInstance.post<User>('/user', user);
    return response?.data;
};

export const updateUser = async (user: User) => {
    const response = await axiosInstance.patch<User>(`/user/${user.id}`, user);
    return response?.data;
};

export const getUsers = async () => {
    const response = await axiosInstance.get<User[]>('/user');
    return response?.data;
};